import React from "react";
import {
  Modal,
  Form,
  Typography,
} from "antd";

const { Text } = Typography;

const CreateIAMUserModal = ({
    loading,
    visible,
    onOk,
    onCancel,
    title,
    okText,
    email,
  }) => {
    const [form] = Form.useForm();
    
    return (
      <Modal
        destroyOnClose={true}
        okButtonProps={{ loading: loading }}
        cancelButtonProps={{ disabled: loading }}
        maskClosable={false}
        visible={visible}
        title={title}
        okText={okText}
        cancelText="Cancel"
        onCancel={onCancel}
        onOk={() => {
          onOk();
        }}
      >
        <div>
          This will create an AWS IAM User for teacher <Text mark>{email}</Text>. This is irreversible. Continue?
        </div>
      </Modal>
    );
};

export default CreateIAMUserModal;